import { useScale } from '#contexts/scaleContext.tsx'
import { type BaseProps, type CompProps, Text } from '#ui/Txt.tsx'
import { cn } from '#utils/cn.ts'
import { getClassFn, type TextClasses } from '#utils/ds.ts'

type PProps = CompProps<'p'> & BaseProps

const classFn = getClassFn<TextClasses>()

export function P({ children, className, ...props }: PProps) {
  const classes = cn(
    useScale() === 'lg' ? 'text-base' : 'text-sm',
    className ? className(classFn) : undefined
  )

  return (
    <Text {...props} as='p' className={x => x('mb-4 last:mb-0', classes)}>
      {children}
    </Text>
  )
}
